import React from "react"
import Layout from "../components/Layout"
import "../css/projects/web-project/web_proj1.css"
import { Link } from "gatsby"
import { FaCode, FaLink } from "react-icons/fa"
import SEO from "../components/SEO"
import Particle8 from "../components/Particle8"

const data_proj2 = () => {
  return (
    <Layout>
      <SEO
        title="Restotante Con Fusion"
        description="Full Fledged Awesome Website Development (Web-Dev) project"
      />
      <Particle8></Particle8>
      <h6>s</h6>

      <section className="noSelect">
        <Link to="/data/">
          <button type="button" className="back-btn noSelect">
            <span>{"<"}= More Projects</span>
          </button>
        </Link>
      </section>

      <section className="proj-name-wrap noSelect">
        <div className="data-img-2">
          <div className="py-1-heading">
            <h1>Finance Data Project</h1>
          </div>
        </div>
        <div className="git">
          <a
            href="https://github.com/arpitsomani8/Data-Capstone-Projects/tree/master/Emergency%20-%20911%20Calls"
            target="_blank"
            rel="noopener noreferrer"
            title="Github code"
          >
            <FaCode className="git-btn"></FaCode>
          </a>
        </div>
        
        <div className="proj-1">
          <div className="p1">
            <h3>Concept Behind It:</h3>
            <p>
              Focused on Exploratory Data Analysis (EDA) of stock prices.
              <br/>
              <br />Import pickle file dataset by pandas
               
              <br />
              Setting all banks data together with concatenation and Continue with data exploration making a DataFrame.
              <br/><br/>
              
              Making a column in dataframe that will contain the returns for each bank's stock using pct_change().
              <br/>
              Figure out on what dates each bank stock had the best and worst single day returns.
               <br/>
              <br/>
              xs() function is used to get cross-section from the Series/DataFrame and visualising it as well.
              <br/> 
              <br /> Used diffrent graph visualisation as per required for EDA<br/>
              Like:- Pairplot, Distplot, iplot, Heatmap, Clustermap, Plotly and cufflinks.
              <br />
            </p>

            <h3>Skills Behind It:</h3>
            <div className="py-skill-1">
              <button type="button" className="btn-py-1" disabled>
                <span>Pandas</span>
              </button>
              <button type="button" className="btn-py-1" disabled>
                <span>Numpy</span>
              </button>
              <button type="button" className="btn-py-1" disabled>
                <span>Matplotlib</span>
              </button>
              <button type="button" className="btn-py-1" disabled>
                <span>Datetime</span>
              </button> 
              <button type="button" className="btn-py-1" disabled>
                <span>Seaborn</span>
              </button> 
              <button type="button" className="btn-py-1" disabled>
                <span>Plotly</span>
              </button>
              <button type="button" className="btn-py-1" disabled>
                <span>cufflinks</span>
              </button>

            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default data_proj2
